<div class="footer" fxLayout="row" fxLayoutAlign="start" fxLayoutGap="15px">
	<span class="version">Version: {{version}}</span>
	<span class="display-none">Build timestamp: {{buildTimestamp}}</span>
	<span>|</span>
	<a class="copyright" href="https://cxtsoftware.com/" target="_blank">&copy; CXT Software {{year}}</a>
</div>
